import { Navigate } from 'react-router-dom';
//Customer Dashboard Pages
import CustomerDashboard from '../pages/Customer/CustomerDashboard';
import CustomerCatalog from '../pages/Customer/Catalog';
import CustomerTemplates from '../pages/Customer/Templates';
import CustomerMyProfile from '../pages/Customer/MyProfile';
import CustomerAccountSettings from '../pages/Customer/AccountSettings';
import CustomerBilling from '../pages/Customer/Billing';
import CustomerNotifications from '../pages/Customer/Notifications';

//Import Google Reviews Apps
import CustomerGoogleReview from '../pages/Customer/Apps/GoogleReview/MyGoogleReview';  
import CustomerCreateGoogleReview from '../pages/Customer/Apps/GoogleReview/CreateGoogleReview';  
import CustomerEditGoogleReview from '../pages/Customer/Apps/GoogleReview/EditGoogleReview'; 
import CustomerGoogleReviewSinglePricingPacks from '../pages/Customer/Apps/GoogleReview/PricingPacks';

//Import Customer Whats App Chat Apps
import CustomerWhatsAppChat from '../pages/Customer/Apps/WhatsAppChat/MyWhatsAppChat';
import CustomerCreateWhatsAppChat from '../pages/Customer/Apps/WhatsAppChat/CreateWhatsAppChat';
import CustomerWishlistWhatsAppChat from '../pages/Customer/Apps/WhatsAppChat/WishlistWhatsAppChat';
import CustomerWhatsNewWhatsAppChat from '../pages/Customer/Apps/WhatsAppChat/WhatsNewWhatsAppChat';
import CustomerEditWhatsAppChat from '../pages/Customer/Apps/WhatsAppChat/EditWhatsAppChat';
import CustomerWhatsAppChatSinglePricingPacks from '../pages/Customer/Apps/WhatsAppChat/PricingPacks';

//Import Customer Click To Call Apps
import CustomerClickToCall from '../pages/Customer/Apps/ClickToCall/MyClickToCall';
import CustomerCreateClickToCall from '../pages/Customer/Apps/ClickToCall/CreateClickToCall';
import CustomerWishlistClickToCall from '../pages/Customer/Apps/ClickToCall/WishlistClickToCall';
import CustomerWhatsNewClickToCall from '../pages/Customer/Apps/ClickToCall/WhatsNewClickToCall';
import CustomerEditClickToCall from '../pages/Customer/Apps/ClickToCall/EditClickToCall';
import CustomerClickToCallSinglePricingPacks from '../pages/Customer/Apps/ClickToCall/PricingPacks'; 

//Import Customer Countdown Timer Apps
import CustomerCountdownTimer from '../pages/Customer/Apps/CountdownTimer/MyCountdownTimer';
import CustomerCreateCountdownTimer from '../pages/Customer/Apps/CountdownTimer/CreateCountdownTimer';
import CustomerWishlistCountdownTimer from '../pages/Customer/Apps/CountdownTimer/WishlistCountdownTimer';
import CustomerWhatsNewCountdownTimer from '../pages/Customer/Apps/CountdownTimer/WhatsNewCountdownTimer';
import CustomerEditCountdownTimer from '../pages/Customer/Apps/CountdownTimer/EditCountdownTimer';
import CustomerCountdownTimerSinglePricingPacks from '../pages/Customer/Apps/CountdownTimer/PricingPacks'; 

//Import Customer Testimonials Apps
import CustomerTestimonials from '../pages/Customer/Apps/Testimonials/MyTestimonials';
import CustomerCreateTestimonials from '../pages/Customer/Apps/Testimonials/CreateTestimonials';
import CustomerWishlistTestimonials from '../pages/Customer/Apps/Testimonials/WishlistTestimonials';
import CustomerWhatsNewTestimonials from '../pages/Customer/Apps/Testimonials/WhatsNewTestimonials';
import CustomerEditTestimonials from '../pages/Customer/Apps/Testimonials/EditTestimonials';
import CustomerTestimonialsSinglePricingPacks from '../pages/Customer/Apps/Testimonials/PricingPacks';

//Import Customer Cookie Consent Apps
import CustomerCookieConsent from '../pages/Customer/Apps/CookieConsent/MyCookieConsent';
import CustomerCreateCookieConsent from '../pages/Customer/Apps/CookieConsent/CreateCookieConsent';
import CustomerEditCookieConsent from '../pages/Customer/Apps/CookieConsent/EditCookieConsent';
import CustomerCookieConsentSinglePricingPacks from '../pages/Customer/Apps/CookieConsent/PricingPacks';

//Import Customer Age Verification Apps
import CustomerAgeVerification from '../pages/Customer/Apps/AgeVerification/MyAgeVerification';
import CustomerCreateAgeVerification from '../pages/Customer/Apps/AgeVerification/CreateAgeVerification';
import CustomerEditAgeVerification from '../pages/Customer/Apps/AgeVerification/EditAgeVerification';
import CustomerAgeVerificationSinglePricingPacks from '../pages/Customer/Apps/AgeVerification/PricingPacks';

//Import Customer Business Hours Apps
import CustomerBusinessHours from '../pages/Customer/Apps/BusinessHours/MyBusinessHours'; 
import CustomerCreateBusinessHours from '../pages/Customer/Apps/BusinessHours/CreateBusinessHours'; 
import CustomerEditBusinessHours from '../pages/Customer/Apps/BusinessHours/EditBusinessHours';
import CustomerBusinessHoursSinglePricingPacks from '../pages/Customer/Apps/BusinessHours/PricingPacks';

//Import Customer Pricing Table Apps
import CustomerPricingTable from '../pages/Customer/Apps/PricingTable/MyPricingTable'; 
import CustomerCreatePricingTable from '../pages/Customer/Apps/PricingTable/CreatePricingTable'; 
import CustomerEditPricingTable from '../pages/Customer/Apps/PricingTable/EditPricingTable';
import CustomerPricingTableSinglePricingPacks from '../pages/Customer/Apps/PricingTable/PricingPacks';

//Import Customer Announcement Bar Apps
import CustomerAnnouncementBar from '../pages/Customer/Apps/AnnouncementBar/MyAnnouncementBar'; 
import CustomerCreateAnnouncementBar from '../pages/Customer/Apps/AnnouncementBar/CreateAnnouncementBar'; 
import CustomerEditAnnouncementBar from '../pages/Customer/Apps/AnnouncementBar/EditAnnouncementBar';
import CustomerAnnouncementBarSinglePricingPacks from '../pages/Customer/Apps/AnnouncementBar/PricingPacks';

//Import Customer Number Counter Apps
import CustomerNumberCounter from '../pages/Customer/Apps/NumberCounter/MyNumberCounters'; 
import CustomerCreateNumberCounter from '../pages/Customer/Apps/NumberCounter/CreateNumberCounter'; 
import CustomerEditNumberCounter from '../pages/Customer/Apps/NumberCounter/EditNumberCounter';
import CustomerNumberCounterSinglePricingPacks from '../pages/Customer/Apps/NumberCounter/PricingPacks';

//Import Customer Photo Gallery Apps
import CustomerPhotoGallery from '../pages/Customer/Apps/PhotoGallery/MyPhotoGallery'; 
import CustomerCreatePhotoGallery from '../pages/Customer/Apps/PhotoGallery/CreatePhotoGallery'; 
import CustomerEditPhotoGallery from '../pages/Customer/Apps/PhotoGallery/EditPhotoGallery';
import CustomerPhotoGallerySinglePricingPacks from '../pages/Customer/Apps/PhotoGallery/PricingPacks';

//Import Customer Back To Top Apps
import CustomerBackToTop from '../pages/Customer/Apps/BackToTop/MyBackToTop'; 
import CustomerCreateBackToTop from '../pages/Customer/Apps/BackToTop/CreateBackToTop'; 
import CustomerEditBackToTop from '../pages/Customer/Apps/BackToTop/EditBackToTop';
import CustomerBackToTopSinglePricingPacks from '../pages/Customer/Apps/BackToTop/PricingPacks';

//Import Customer Social Media Icons Apps
import CustomerSocialMediaIcons from '../pages/Customer/Apps/SocialMediaIcons/MySocialMediaIcons'; 
import CustomerCreateSocialMediaIcons from '../pages/Customer/Apps/SocialMediaIcons/CreateSocialMediaIcons'; 
import CustomerEditSocialMediaIcons from '../pages/Customer/Apps/SocialMediaIcons/EditSocialMediaIcons';
import CustomerSocialMediaIconsSinglePricingPacks from '../pages/Customer/Apps/SocialMediaIcons/PricingPacks';

//Import Customer Facebook Like Button Apps
import CustomerFacebookLikeButton from '../pages/Customer/Apps/FacebookLikeButton/MyFacebookLikeButton'; 
import CustomerCreateFacebookLikeButton from '../pages/Customer/Apps/FacebookLikeButton/CreateFacebookLikeButton'; 
import CustomerEditFacebookLikeButton from '../pages/Customer/Apps/FacebookLikeButton/EditFacebookLikeButton';
import CustomerFacebookLikeButtonSinglePricingPacks from '../pages/Customer/Apps/FacebookLikeButton/PricingPacks';

//Import Customer Facebook Share Button Apps
import CustomerFacebookShareButton from '../pages/Customer/Apps/FacebookShareButton/MyFacebookShareButton'; 
import CustomerCreateFacebookShareButton from '../pages/Customer/Apps/FacebookShareButton/CreateFacebookShareButton'; 
import CustomerEditFacebookShareButton from '../pages/Customer/Apps/FacebookShareButton/EditFacebookShareButton';
import CustomerFacebookShareButtonSinglePricingPacks from '../pages/Customer/Apps/FacebookShareButton/PricingPacks';

//Import Customer QR Code Apps
import CustomerQRCode from '../pages/Customer/Apps/QRCode/MyQRCode'; 
import CustomerCreateQRCode from '../pages/Customer/Apps/QRCode/CreateQRCode'; 
import CustomerEditQRCode from '../pages/Customer/Apps/QRCode/EditQRCode';
import CustomerQRCodeSinglePricingPacks from '../pages/Customer/Apps/QRCode/PricingPacks';

//Import Customer Logo Showcase Apps
import CustomerLogoShowcase from '../pages/Customer/Apps/LogoShowcase/MyLogoShowcase'; 
import CustomerCreateLogoShowcase from '../pages/Customer/Apps/LogoShowcase/CreateLogoShowcase'; 
import CustomerEditLogoShowcase from '../pages/Customer/Apps/LogoShowcase/EditLogoShowcase';
import CustomerLogoShowcaseSinglePricingPacks from '../pages/Customer/Apps/LogoShowcase/PricingPacks';

//Import Customer Team Showcase Apps
import CustomerTeamShowcase from '../pages/Customer/Apps/TeamShowcase/MyTeamShowcase'; 
import CustomerCreateTeamShowcase from '../pages/Customer/Apps/TeamShowcase/CreateTeamShowcase'; 
import CustomerEditTeamShowcase from '../pages/Customer/Apps/TeamShowcase/EditTeamShowcase';
import CustomerTeamShowcaseSinglePricingPacks from '../pages/Customer/Apps/TeamShowcase/PricingPacks';

//Import Customer Faq Apps
import CustomerFaq from '../pages/Customer/Apps/Faq/MyFaq';  
import CustomerCreateFaq from '../pages/Customer/Apps/Faq/CreateFaq';  
import CustomerEditFaq from '../pages/Customer/Apps/Faq/EditFaq'; 
import CustomerFaqSinglePricingPacks from '../pages/Customer/Apps/Faq/PricingPacks';

//Import Amazon Reviews Apps
import CustomerAmazonReview from '../pages/Customer/Apps/AmazonReviews/MyAmazonReview';  
import CustomerCreateAmazonReview from '../pages/Customer/Apps/AmazonReviews/CreateAmazonReview';  
import CustomerEditAmazonReview from '../pages/Customer/Apps/AmazonReviews/EditAmazonReview'; 
import CustomerAmazonReviewSinglePricingPacks from '../pages/Customer/Apps/AmazonReviews/PricingPacks';

//Import AliExpress Reviews Apps
import CustomerAliExpress from '../pages/Customer/Apps/AliExpressReviews/MyAliExpress';  
import CustomerCreateAliExpress from '../pages/Customer/Apps/AliExpressReviews/CreateAliExpress';  
import CustomerEditAliExpress from '../pages/Customer/Apps/AliExpressReviews/EditAliExpress'; 
import CustomerAliExpressSinglePricingPacks from '../pages/Customer/Apps/AliExpressReviews/PricingPacks';

//Import Yelp Reviews Apps
import CustomerYelpReview from '../pages/Customer/Apps/YelpReview/MyYelpReview';  
import CustomerCreateYelpReview from '../pages/Customer/Apps/YelpReview/CreateYelpReview';  
import CustomerEditYelpReview from '../pages/Customer/Apps/YelpReview/EditYelpReview'; 
import CustomerYelpReviewSinglePricingPacks from '../pages/Customer/Apps/YelpReview/PricingPacks';

//Import G2 Reviews Apps
import CustomerG2Review from '../pages/Customer/Apps/G2Review/MyG2Review';  
import CustomerCreateG2Review from '../pages/Customer/Apps/G2Review/CreateG2Review';  
import CustomerEditG2Review from '../pages/Customer/Apps/G2Review/EditG2Review'; 
import CustomerG2ReviewSinglePricingPacks from '../pages/Customer/Apps/G2Review/PricingPacks';

//Import Hotels Reviews Apps
import CustomerHotelsReview from '../pages/Customer/Apps/HotelsReview/MyHotelsReview';  
import CustomerCreateHotelsReview from '../pages/Customer/Apps/HotelsReview/CreateHotelsReview';  
import CustomerEditHotelsReview from '../pages/Customer/Apps/HotelsReview/EditHotelsReview'; 
import CustomerHotelsReviewSinglePricingPacks from '../pages/Customer/Apps/HotelsReview/PricingPacks';

//Import App Store Reviews Apps
import CustomerAppStoreReview from '../pages/Customer/Apps/AppStoreReview/MyAppStoreReview';  
import CustomerCreateAppStoreReview from '../pages/Customer/Apps/AppStoreReview/CreateAppStoreReview';  
import CustomerEditAppStoreReview from '../pages/Customer/Apps/AppStoreReview/EditAppStoreReview'; 
import CustomerAppStoreReviewSinglePricingPacks from '../pages/Customer/Apps/AppStoreReview/PricingPacks';

//Import Capterra Reviews Apps
import CustomerCapterraReview from '../pages/Customer/Apps/CapterraReview/MyCapterraReview';  
import CustomerCreateCapterraReview from '../pages/Customer/Apps/CapterraReview/CreateCapterraReview';  
import CustomerEditCapterraReview from '../pages/Customer/Apps/CapterraReview/EditCapterraReview'; 
import CustomerCapterraReviewSinglePricingPacks from '../pages/Customer/Apps/CapterraReview/PricingPacks';

//Import Booking Reviews Apps
import CustomerBookingReview from '../pages/Customer/Apps/BookingReview/MyBookingReview';  
import CustomerCreateBookingReview from '../pages/Customer/Apps/BookingReview/CreateBookingReview';  
import CustomerEditBookingReview from '../pages/Customer/Apps/BookingReview/EditBookingReview'; 
import CustomerBookingReviewSinglePricingPacks from '../pages/Customer/Apps/BookingReview/PricingPacks';

//Import Tripadvisor Reviews Apps
import CustomerTripadvisorReview from '../pages/Customer/Apps/TripadvisorReview/MyTripadvisorReview';  
import CustomerCreateTripadvisorReview from '../pages/Customer/Apps/TripadvisorReview/CreateTripadvisorReview';  
import CustomerEditTripadvisorReview from '../pages/Customer/Apps/TripadvisorReview/EditTripadvisorReview'; 
import CustomerTripadvisorReviewSinglePricingPacks from '../pages/Customer/Apps/TripadvisorReview/PricingPacks';

//Import Airbnb Reviews Apps
import CustomerAirbnbReview from '../pages/Customer/Apps/AirbnbReview/MyAirbnbReview';  
import CustomerCreateAirbnbReview from '../pages/Customer/Apps/AirbnbReview/CreateAirbnbReview';  
import CustomerEditAirbnbReview from '../pages/Customer/Apps/AirbnbReview/EditAirbnbReview'; 
import CustomerAirbnbReviewSinglePricingPacks from '../pages/Customer/Apps/AirbnbReview/PricingPacks';

//Import BBB Reviews Apps
import CustomerBBBReview from '../pages/Customer/Apps/BBBReview/MyBBBReview';  
import CustomerCreateBBBReview from '../pages/Customer/Apps/BBBReview/CreateBBBReview';  
import CustomerEditBBBReview from '../pages/Customer/Apps/BBBReview/EditBBBReview'; 
import CustomerBBBReviewSinglePricingPacks from '../pages/Customer/Apps/BBBReview/PricingPacks';

//Import Etsy Reviews Apps
import CustomerEtsyReview from '../pages/Customer/Apps/EtsyReview/MyEtsyReview';  
import CustomerCreateEtsyReview from '../pages/Customer/Apps/EtsyReview/CreateEtsyReview';  
import CustomerEditEtsyReview from '../pages/Customer/Apps/EtsyReview/EditEtsyReview'; 
import CustomerEtsyReviewSinglePricingPacks from '../pages/Customer/Apps/EtsyReview/PricingPacks';

//Import Facebook Reviews Apps
import CustomerFacebookReview from '../pages/Customer/Apps/FacebookReview/MyFacebookReview';  
import CustomerCreateFacebookReview from '../pages/Customer/Apps/FacebookReview/CreateFacebookReview';  
import CustomerEditFacebookReview from '../pages/Customer/Apps/FacebookReview/EditFacebookReview'; 
import CustomerFacebookReviewSinglePricingPacks from '../pages/Customer/Apps/FacebookReview/PricingPacks';

//Import OpenTable Reviews Apps
import CustomerOpenTableReview from '../pages/Customer/Apps/OpenTableReview/MyOpenTableReview';  
import CustomerCreateOpenTableReview from '../pages/Customer/Apps/OpenTableReview/CreateOpenTableReview';  
import CustomerEditOpenTableReview from '../pages/Customer/Apps/OpenTableReview/EditOpenTableReview'; 
import CustomerOpenTableReviewSinglePricingPacks from '../pages/Customer/Apps/OpenTableReview/PricingPacks';

//Import Instagram Feed Apps
import CustomerInstagramFeed from '../pages/Customer/Apps/InstagramFeed/MyInstagramFeed';  
import CustomerCreateInstagramFeed from '../pages/Customer/Apps/InstagramFeed/CreateInstagramFeed';  
import CustomerEditInstagramFeed from '../pages/Customer/Apps/InstagramFeed/EditInstagramFeed'; 
import CustomerInstagramFeedSinglePricingPacks from '../pages/Customer/Apps/InstagramFeed/PricingPacks';

//Import Instagram Chat
import CustomerInstagramChat from '../pages/Customer/Apps/InstagramAppChat/MyInstagramChat';  
import CustomerCreateInstagramChat from '../pages/Customer/Apps/InstagramAppChat/CreateInstagramChat';  
import CustomerEditInstagramChat from '../pages/Customer/Apps/InstagramAppChat/EditInstagramChat'; 
import CustomerInstagramChatSinglePricingPacks from '../pages/Customer/Apps/InstagramAppChat/PricingPacks';

//Import Telegram Chat
import CustomerTelegramChat from '../pages/Customer/Apps/TelegramAppChat/MyTelegramChat';  
import CustomerCreateTelegramChat from '../pages/Customer/Apps/TelegramAppChat/CreateTelegramChat';  
import CustomerEditTelegramChat from '../pages/Customer/Apps/TelegramAppChat/EditTelegramChat'; 
import CustomerTelegramChatSinglePricingPacks from '../pages/Customer/Apps/TelegramAppChat/PricingPacks';

//Import Line Chat
import CustomerLineChat from '../pages/Customer/Apps/LineAppChat/MyLineChat';  
import CustomerCreateLineChat from '../pages/Customer/Apps/LineAppChat/CreateLineChat';  
import CustomerEditLineChat from '../pages/Customer/Apps/LineAppChat/EditLineChat'; 
import CustomerLineChatSinglePricingPacks from '../pages/Customer/Apps/LineAppChat/PricingPacks';

//Import Viber Chat
import CustomerViberChat from '../pages/Customer/Apps/ViberAppChat/MyViberChat';  
import CustomerCreateViberChat from '../pages/Customer/Apps/ViberAppChat/CreateViberChat';  
import CustomerEditViberChat from '../pages/Customer/Apps/ViberAppChat/EditViberChat'; 
import CustomerViberChatSinglePricingPacks from '../pages/Customer/Apps/ViberAppChat/PricingPacks';

//Import Facebook Chat
import CustomerFacebookChat from '../pages/Customer/Apps/FacebookAppChat/MyFacebookChat';  
import CustomerCreateFacebookChat from '../pages/Customer/Apps/FacebookAppChat/CreateFacebookChat';  
import CustomerEditFacebookChat from '../pages/Customer/Apps/FacebookAppChat/EditFacebookChat'; 
import CustomerFacebookChatSinglePricingPacks from '../pages/Customer/Apps/FacebookAppChat/PricingPacks';

//Import AI ChatBot Chat
import CustomerAIChatBot from '../pages/Customer/Apps/AIChatBot/MyAIChatBot';  
import CustomerCreateAIChatBot from '../pages/Customer/Apps/AIChatBot/CreateAIChatBot';  
import CustomerEditAIChatBot from '../pages/Customer/Apps/AIChatBot/EditAIChatBot'; 
import CustomerAIChatBotSinglePricingPacks from '../pages/Customer/Apps/AIChatBot/PricingPacks';

//Import Spinning Wheel
import CustomerSpinningWheel from '../pages/Customer/Apps/SpinningWheel/MySpinningWheel';  
import CustomerCreateSpinningWheel from '../pages/Customer/Apps/SpinningWheel/CreateSpinningWheel';  
import CustomerEditSpinningWheel from '../pages/Customer/Apps/SpinningWheel/EditSpinningWheel'; 
import CustomerSpinningWheelSinglePricingPacks from '../pages/Customer/Apps/SpinningWheel/PricingPacks';

//Import Pdf Embed
import CustomerPdfEmbed from '../pages/Customer/Apps/PdfEmbed/MyPdfEmbed';  
import CustomerCreatePdfEmbed from '../pages/Customer/Apps/PdfEmbed/CreatePdfEmbed';  
import CustomerEditPdfEmbed from '../pages/Customer/Apps/PdfEmbed/EditPdfEmbed'; 
import CustomerPdfEmbedSinglePricingPacks from '../pages/Customer/Apps/PdfEmbed/PricingPacks';

//Import File Embed
import CustomerFileEmbed from '../pages/Customer/Apps/FileEmbed/MyFileEmbed';  
import CustomerCreateFileEmbed from '../pages/Customer/Apps/FileEmbed/CreateFileEmbed';  
import CustomerEditFileEmbed from '../pages/Customer/Apps/FileEmbed/EditFileEmbed'; 
import CustomerFileEmbedSinglePricingPacks from '../pages/Customer/Apps/FileEmbed/PricingPacks';

//Import PayPal Button
import CustomerPayPalButton from '../pages/Customer/Apps/PayPalButton/MyPayPalButton';  
import CustomerCreatePayPalButton from '../pages/Customer/Apps/PayPalButton/CreatePayPalButton';  
import CustomerEditPayPalButton from '../pages/Customer/Apps/PayPalButton/EditPayPalButton'; 
import CustomerPayPalButtonSinglePricingPacks from '../pages/Customer/Apps/PayPalButton/PricingPacks';

const customerRoutes = [
  {
    path: '/customer/dashboard',
    element: <CustomerDashboard />
  },
  {
    path: '/customer/catalog',
    element: <CustomerCatalog />
  },
  {
    path: '/customer/templates',
    element: <CustomerTemplates />
  },
  {
    path: '/customer/my-profile',
    element: <CustomerMyProfile/>
  },
  {
    path: '/customer/account-setting',
    element: <CustomerAccountSettings/>
  },
  {
    path: '/customer/billing',
    element: <CustomerBilling/>
  },
  {
    path: '/customer/notifications',
    element: <CustomerNotifications/>
  },
  {
    path: '/customer/apps/google-reviews',
    element: <CustomerGoogleReview/>
  },
  {
    path: '/customer/create/google-reviews',
    element: <CustomerCreateGoogleReview/>
  },
  {
    path: '/customer/edit/google-reviews/:uuid',
    element: <CustomerEditGoogleReview/>
  },
  {
    path: '/customer/apps/google-reviews/pricing/single',
    element: <CustomerGoogleReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/whats-app-chat',
    element: <CustomerWhatsAppChat/>
  },
  {
    path: '/customer/create/whats-app-chat',
    element: <CustomerCreateWhatsAppChat/>
  },
  {
    path: '/customer/apps/whats-app-chat/wishlist',
    element: <CustomerWishlistWhatsAppChat/>
  },
  {
    path: '/customer/apps/whats-app-chat/whats-new',
    element: <CustomerWhatsNewWhatsAppChat/>
  },
  {
    path: '/customer/edit/whats-app-chat/:uuid',
    element: <CustomerEditWhatsAppChat/>
  },
  {
    path: '/customer/apps/whats-app-chat/pricing/single',
    element: <CustomerWhatsAppChatSinglePricingPacks/>
  },
  {
    path: '/customer/apps/click-to-call',
    element: <CustomerClickToCall/>
  },
  {
    path: '/customer/create/click-to-call',
    element: <CustomerCreateClickToCall/>
  },
  {
    path: '/customer/click-to-call/wishlist',
    element: <CustomerWishlistClickToCall/>
  },
  {
    path: '/customer/apps/click-to-call/whats-new',
    element: <CustomerWhatsNewClickToCall/>
  },
  {
    path: '/customer/edit/click-to-call/:uuid',
    element: <CustomerEditClickToCall/>
  },
  {
    path: '/customer/apps/click-to-call/pricing/single',
    element: <CustomerClickToCallSinglePricingPacks/>
  },
  {
    path: '/customer/apps/countdown-timer',
    element: <CustomerCountdownTimer/>
  },
  {
    path: '/customer/create/countdown-timer',
    element: <CustomerCreateCountdownTimer/>
  },
  {
    path: '/customer/apps/countdown-timer/wishlist',
    element: <CustomerWishlistCountdownTimer/>
  },
  {
    path: '/customer/apps/countdown-timer/whats-new',
    element: <CustomerWhatsNewCountdownTimer/>
  },
  {
    path: '/customer/edit/countdown-timer/:uuid',
    element: <CustomerEditCountdownTimer/>
  },
  {
    path: '/customer/apps/countdown-timer/pricing/single',
    element: <CustomerCountdownTimerSinglePricingPacks/>
  },
  {
    path: '/customer/apps/testimonials',
    element: <CustomerTestimonials/>
  },
  {
    path: '/customer/create/testimonials',
    element: <CustomerCreateTestimonials/>
  },
  {
    path: '/customer/apps/testimonials/wishlist',
    element: <CustomerWishlistTestimonials/>
  },
  {
    path: '/customer/apps/testimonials/whats-new',
    element: <CustomerWhatsNewTestimonials/>
  },
  {
    path: '/customer/edit/testimonials/:uuid',
    element: <CustomerEditTestimonials/>
  },
  {
    path: '/customer/apps/testimonials/pricing/single',
    element: <CustomerTestimonialsSinglePricingPacks/>
  },
  {
    path: '/customer/apps/cookie-consent',
    element: <CustomerCookieConsent/>
  },
  {
    path: '/customer/create/cookie-consent',
    element: <CustomerCreateCookieConsent/>
  },
  {
    path: '/customer/edit/cookie-consent/:uuid',
    element: <CustomerEditCookieConsent/>
  },
  {
    path: '/customer/apps/cookie-consent/pricing/single',
    element: <CustomerCookieConsentSinglePricingPacks/>
  },
  {
    path: '/customer/apps/age-verification',
    element: <CustomerAgeVerification/>
  },
  {
    path: '/customer/create/age-verification',
    element: <CustomerCreateAgeVerification/>
  },
  {
    path: '/customer/edit/age-verification/:uuid',
    element: <CustomerEditAgeVerification/>
  },
  {
    path: '/customer/apps/age-verification/pricing/single',
    element: <CustomerAgeVerificationSinglePricingPacks/>
  },
  {
    path: '/customer/apps/business-hours',
    element: <CustomerBusinessHours/>
  },
  {
    path: '/customer/create/business-hours',
    element: <CustomerCreateBusinessHours/>
  },
  {
    path: '/customer/edit/business-hours/:uuid',
    element: <CustomerEditBusinessHours/>
  },
  {
    path: '/customer/apps/business-hours/pricing/single',
    element: <CustomerBusinessHoursSinglePricingPacks/>
  },
  {
    path: '/customer/apps/pricing-table',
    element: <CustomerPricingTable/>
  },
  {
    path: '/customer/create/pricing-table',
    element: <CustomerCreatePricingTable/>
  },
  {
    path: '/customer/edit/pricing-table/:uuid',
    element: <CustomerEditPricingTable/>
  },
  {
    path: '/customer/apps/pricing-table/pricing/single',
    element: <CustomerPricingTableSinglePricingPacks/>
  },
  {
    path: '/customer/apps/announcement-bar',
    element: <CustomerAnnouncementBar/>
  },
  {
    path: '/customer/create/announcement-bar',
    element: <CustomerCreateAnnouncementBar/>
  },
  {
    path: '/customer/edit/announcement-bar/:uuid',
    element: <CustomerEditAnnouncementBar/>
  },
  {
    path: '/customer/apps/announcement-bar/pricing/single',
    element: <CustomerAnnouncementBarSinglePricingPacks/>
  },
  {
    path: '/customer/apps/number-counter',
    element: <CustomerNumberCounter/>
  },
  {
    path: '/customer/create/number-counter',
    element: <CustomerCreateNumberCounter/>
  },
  {
    path: '/customer/edit/number-counter/:uuid',
    element: <CustomerEditNumberCounter/>
  },
  {
    path: '/customer/apps/number-counter/pricing/single',
    element: <CustomerNumberCounterSinglePricingPacks/>
  },
  {
    path: '/customer/apps/photo-gallery',
    element: <CustomerPhotoGallery/>
  },
  {
    path: '/customer/create/photo-gallery',
    element: <CustomerCreatePhotoGallery/>
  },
  {
    path: '/customer/edit/photo-gallery/:uuid',
    element: <CustomerEditPhotoGallery/>
  },
  {
    path: '/customer/apps/photo-gallery/pricing/single',
    element: <CustomerPhotoGallerySinglePricingPacks/>
  },
  {
    path: '/customer/apps/back-to-top',
    element: <CustomerBackToTop/>
  },
  {
    path: '/customer/create/back-to-top',
    element: <CustomerCreateBackToTop/>
  },
  {
    path: '/customer/edit/back-to-top/:uuid',
    element: <CustomerEditBackToTop/>
  },
  {
    path: '/customer/apps/back-to-top/pricing/single',
    element: <CustomerBackToTopSinglePricingPacks/>
  },
  {
    path: '/customer/apps/social-media-icons',
    element: <CustomerSocialMediaIcons/>
  },
  {
    path: '/customer/create/social-media-icons',
    element: <CustomerCreateSocialMediaIcons/>
  },
  {
    path: '/customer/edit/social-media-icons/:uuid',
    element: <CustomerEditSocialMediaIcons/>
  },
  {
    path: '/customer/apps/social-media-icons/pricing/single',
    element: <CustomerSocialMediaIconsSinglePricingPacks/>
  },
  {
    path: '/customer/apps/facebook-like-button',
    element: <CustomerFacebookLikeButton/>
  },
  {
    path: '/customer/create/facebook-like-button',
    element: <CustomerCreateFacebookLikeButton/>
  },
  {
    path: '/customer/edit/facebook-like-button/:uuid',
    element: <CustomerEditFacebookLikeButton/>
  },
  {
    path: '/customer/apps/facebook-like-button/pricing/single',
    element: <CustomerFacebookLikeButtonSinglePricingPacks/>
  },
  {
    path: '/customer/apps/facebook-share-button',
    element: <CustomerFacebookShareButton/>
  },
  {
    path: '/customer/create/facebook-share-button',
    element: <CustomerCreateFacebookShareButton/>
  },
  {
    path: '/customer/edit/facebook-share-button/:uuid',
    element: <CustomerEditFacebookShareButton/>
  },
  {
    path: '/customer/apps/facebook-share-button/pricing/single',
    element: <CustomerFacebookShareButtonSinglePricingPacks/>
  },
  {
    path: '/customer/apps/qr-code',
    element: <CustomerQRCode/>
  },
  {
    path: '/customer/create/qr-code',
    element: <CustomerCreateQRCode/>
  },
  {
    path: '/customer/edit/qr-code/:uuid',
    element: <CustomerEditQRCode/>
  },
  {
    path: '/customer/apps/qr-code/pricing/single',
    element: <CustomerQRCodeSinglePricingPacks/>
  },
  {
    path: '/customer/apps/logo-showcase',
    element: <CustomerLogoShowcase/>
  },
  {
    path: '/customer/create/logo-showcase',
    element: <CustomerCreateLogoShowcase/>
  },
  {
    path: '/customer/edit/logo-showcase/:uuid',
    element: <CustomerEditLogoShowcase/>
  },
  {
    path: '/customer/apps/logo-showcase/pricing/single',
    element: <CustomerLogoShowcaseSinglePricingPacks/>
  },
  {
    path: '/customer/apps/team-showcase',
    element: <CustomerTeamShowcase/>
  },
  {
    path: '/customer/create/team-showcase',
    element: <CustomerCreateTeamShowcase/>
  },
  {
    path: '/customer/edit/team-showcase/:uuid',
    element: <CustomerEditTeamShowcase/>
  },
  {
    path: '/customer/apps/team-showcase/pricing/single',
    element: <CustomerTeamShowcaseSinglePricingPacks/>
  },
  {
    path: '/customer/apps/faq',
    element: <CustomerFaq/>
  },
  {
    path: '/customer/create/faq',
    element: <CustomerCreateFaq/>
  },
  {
    path: '/customer/edit/faq/:uuid',
    element: <CustomerEditFaq/>
  },
  {
    path: '/customer/apps/faq/pricing/single',
    element: <CustomerFaqSinglePricingPacks/>
  },
  {
    path: '/customer/apps/amazon-reviews',
    element: <CustomerAmazonReview/>
  },
  {
    path: '/customer/create/amazon-reviews',
    element: <CustomerCreateAmazonReview/>
  },
  {
    path: '/customer/edit/amazon-reviews/:uuid',
    element: <CustomerEditAmazonReview/>
  },
  {
    path: '/customer/apps/amazon-reviews/pricing/single',
    element: <CustomerAmazonReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/aliexpress-reviews',
    element: <CustomerAliExpress/>
  },
  {
    path: '/customer/create/aliexpress-reviews',
    element: <CustomerCreateAliExpress/>
  },
  {
    path: '/customer/edit/aliexpress-reviews/:uuid',
    element: <CustomerEditAliExpress/>
  },
  {
    path: '/customer/apps/aliexpress-reviews/pricing/single',
    element: <CustomerAliExpressSinglePricingPacks/>
  },
  {
    path: '/customer/apps/yelp-reviews',
    element: <CustomerYelpReview/>
  },
  {
    path: '/customer/create/yelp-reviews',
    element: <CustomerCreateYelpReview/>
  },
  {
    path: '/customer/edit/yelp-reviews/:uuid',
    element: <CustomerEditYelpReview/>
  },
  {
    path: '/customer/apps/yelp-reviews/pricing/single',
    element: <CustomerYelpReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/g2-reviews',
    element: <CustomerG2Review/>
  },
  {
    path: '/customer/create/g2-reviews',
    element: <CustomerCreateG2Review/>
  },
  {
    path: '/customer/edit/g2-reviews/:uuid',
    element: <CustomerEditG2Review/>
  },
  {
    path: '/customer/apps/g2-reviews/pricing/single',
    element: <CustomerG2ReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/hotels-reviews',
    element: <CustomerHotelsReview/>
  },
  {
    path: '/customer/create/hotels-reviews',
    element: <CustomerCreateHotelsReview/>
  },
  {
    path: '/customer/edit/hotels-reviews/:uuid',
    element: <CustomerEditHotelsReview/>
  },
  {
    path: '/customer/apps/hotels-reviews/pricing/single',
    element: <CustomerHotelsReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/app-store-reviews',
    element: <CustomerAppStoreReview/>
  },
  {
    path: '/customer/create/app-store-reviews',
    element: <CustomerCreateAppStoreReview/>
  },
  {
    path: '/customer/edit/app-store-reviews/:uuid',
    element: <CustomerEditAppStoreReview/>
  },
  {
    path: '/customer/apps/app-store-reviews/pricing/single',
    element: <CustomerAppStoreReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/capterra-reviews',
    element: <CustomerCapterraReview/>
  },
  {
    path: '/customer/create/capterra-reviews',
    element: <CustomerCreateCapterraReview/>
  },
  {
    path: '/customer/edit/capterra-reviews/:uuid',
    element: <CustomerEditCapterraReview/>
  },
  {
    path: '/customer/apps/capterra-reviews/pricing/single',
    element: <CustomerCapterraReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/tripadvisor-reviews',
    element: <CustomerTripadvisorReview/>
  },
  {
    path: '/customer/create/tripadvisor-reviews',
    element: <CustomerCreateTripadvisorReview/>
  },
  {
    path: '/customer/edit/tripadvisor-reviews/:uuid',
    element: <CustomerEditTripadvisorReview/>
  },
  {
    path: '/customer/apps/tripadvisor-reviews/pricing/single',
    element: <CustomerTripadvisorReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/booking-reviews',
    element: <CustomerBookingReview/>
  },
  {
    path: '/customer/create/booking-reviews',
    element: <CustomerCreateBookingReview/>
  },
  {
    path: '/customer/edit/booking-reviews/:uuid',
    element: <CustomerEditBookingReview/>
  },
  {
    path: '/customer/apps/booking-reviews/pricing/single',
    element: <CustomerBookingReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/airbnb-reviews',
    element: <CustomerAirbnbReview/>
  },
  {
    path: '/customer/create/airbnb-reviews',
    element: <CustomerCreateAirbnbReview/>
  },
  {
    path: '/customer/edit/airbnb-reviews/:uuid',
    element: <CustomerEditAirbnbReview/>
  },
  {
    path: '/customer/apps/airbnb-reviews/pricing/single',
    element: <CustomerAirbnbReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/bbb-reviews',
    element: <CustomerBBBReview/>
  },
  {
    path: '/customer/create/bbb-reviews',
    element: <CustomerCreateBBBReview/>
  },
  {
    path: '/customer/edit/bbb-reviews/:uuid',
    element: <CustomerEditBBBReview/>
  },
  {
    path: '/customer/apps/bbb-reviews/pricing/single',
    element: <CustomerBBBReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/etsy-reviews',
    element: <CustomerEtsyReview/>
  },
  {
    path: '/customer/create/etsy-reviews',
    element: <CustomerCreateEtsyReview/>
  },
  {
    path: '/customer/edit/etsy-reviews/:uuid',
    element: <CustomerEditEtsyReview/>
  },
  {
    path: '/customer/apps/etsy-reviews/pricing/single',
    element: <CustomerEtsyReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/facebook-reviews',
    element: <CustomerFacebookReview/>
  },
  {
    path: '/customer/create/facebook-reviews',
    element: <CustomerCreateFacebookReview/>
  },
  {
    path: '/customer/edit/facebook-reviews/:uuid',
    element: <CustomerEditFacebookReview/>
  },
  {
    path: '/customer/apps/facebook-reviews/pricing/single',
    element: <CustomerFacebookReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/opentable-reviews',
    element: <CustomerOpenTableReview/>
  },
  {
    path: '/customer/create/opentable-reviews',
    element: <CustomerCreateOpenTableReview/>
  },
  {
    path: '/customer/edit/opentable-reviews/:uuid',
    element: <CustomerEditOpenTableReview/>
  },
  {
    path: '/customer/apps/opentable-reviews/pricing/single',
    element: <CustomerOpenTableReviewSinglePricingPacks/>
  },
  {
    path: '/customer/apps/instagram-feed',
    element: <CustomerInstagramFeed/>
  },
  {
    path: '/customer/create/instagram-feed',
    element: <CustomerCreateInstagramFeed/>
  },
  {
    path: '/customer/edit/instagram-feed/:uuid',
    element: <CustomerEditInstagramFeed/>
  },
  {
    path: '/customer/apps/instagram-feed/pricing/single',
    element: <CustomerInstagramFeedSinglePricingPacks/>
  },
  {
    path: '/customer/apps/instagram-chat',
    element: <CustomerInstagramChat/>
  },
  {
    path: '/customer/create/instagram-chat',
    element: <CustomerCreateInstagramChat/>
  },
  {
    path: '/customer/edit/instagram-chat/:uuid',
    element: <CustomerEditInstagramChat/>
  },
  {
    path: '/customer/apps/instagram-chat/pricing/single',
    element: <CustomerInstagramChatSinglePricingPacks/>
  },
  {
    path: '/customer/apps/telegram-chat',
    element: <CustomerTelegramChat/>
  },
  {
    path: '/customer/create/telegram-chat',
    element: <CustomerCreateTelegramChat/>
  },
  {
    path: '/customer/edit/telegram-chat/:uuid',
    element: <CustomerEditTelegramChat/>
  },
  {
    path: '/customer/apps/telegram-chat/pricing/single',
    element: <CustomerTelegramChatSinglePricingPacks/>
  },
  {
    path: '/customer/apps/line-chat',
    element: <CustomerLineChat/>
  },
  {
    path: '/customer/create/line-chat',
    element: <CustomerCreateLineChat/>
  },
  {
    path: '/customer/edit/line-chat/:uuid',
    element: <CustomerEditLineChat/>
  },
  {
    path: '/customer/apps/line-chat/pricing/single',
    element: <CustomerLineChatSinglePricingPacks/>
  },
  {
    path: '/customer/apps/viber-chat',
    element: <CustomerViberChat/>
  },
  {
    path: '/customer/create/viber-chat',
    element: <CustomerCreateViberChat/>
  },
  {
    path: '/customer/edit/viber-chat/:uuid',
    element: <CustomerEditViberChat/>
  },
  {
    path: '/customer/apps/viber-chat/pricing/single',
    element: <CustomerViberChatSinglePricingPacks/>
  },
  {
    path: '/customer/apps/facebook-chat',
    element: <CustomerFacebookChat/>
  },
  {
    path: '/customer/create/facebook-chat',
    element: <CustomerCreateFacebookChat/>
  },
  {
    path: '/customer/edit/facebook-chat/:uuid',
    element: <CustomerEditFacebookChat/>
  },
  {
    path: '/customer/apps/facebook-chat/pricing/single',
    element: <CustomerFacebookChatSinglePricingPacks/>
  },
  {
    path: '/customer/apps/ai-chatbot',
    element: <CustomerAIChatBot/>
  },
  {
    path: '/customer/create/ai-chatbot',
    element: <CustomerCreateAIChatBot/>
  },
  {
    path: '/customer/edit/ai-chatbot/:uuid',
    element: <CustomerEditAIChatBot/>
  },
  {
    path: '/customer/apps/ai-chatbot/pricing/single',
    element: <CustomerAIChatBotSinglePricingPacks/>
  },
  {
    path: '/customer/apps/spinning-wheel',
    element: <CustomerSpinningWheel/>
  },
  {
    path: '/customer/create/spinning-wheel',
    element: <CustomerCreateSpinningWheel/>
  },
  {
    path: '/customer/edit/spinning-wheel/:uuid',
    element: <CustomerEditSpinningWheel/>
  },
  {
    path: '/customer/apps/spinning-wheel/pricing/single',
    element: <CustomerSpinningWheelSinglePricingPacks/>
  },
  {
    path: '/customer/apps/pdf-embed',
    element: <CustomerPdfEmbed/>
  },
  {
    path: '/customer/create/pdf-embed',
    element: <CustomerCreatePdfEmbed/>
  },
  {
    path: '/customer/edit/pdf-embed/:uuid',
    element: <CustomerEditPdfEmbed/>
  },
  {
    path: '/customer/apps/pdf-embed/pricing/single',
    element: <CustomerPdfEmbedSinglePricingPacks/>
  },
  {
    path: '/customer/apps/file-embed',
    element: <CustomerFileEmbed/>
  },
  {
    path: '/customer/create/file-embed',
    element: <CustomerCreateFileEmbed/>
  },
  {
    path: '/customer/edit/file-embed/:uuid',
    element: <CustomerEditFileEmbed/>
  },
  {
    path: '/customer/apps/file-embed/pricing/single',
    element: <CustomerFileEmbedSinglePricingPacks/>
  },
  {
    path: '/customer/apps/paypal-button',
    element: <CustomerPayPalButton/>
  },
  {
    path: '/customer/create/paypal-button',
    element: <CustomerCreatePayPalButton/>
  },
  {
    path: '/customer/edit/paypal-button/:uuid',
    element: <CustomerEditPayPalButton/>
  },
  {
    path: '/customer/apps/paypal-button/pricing/single',
    element: <CustomerPayPalButtonSinglePricingPacks/>
  },
  {
    path: '/admin/*',
    element: <Navigate to="/customer/apps/google-reviews" replace />
  },
  {
    path: '*',
    element: <Navigate to="/customer/apps/google-reviews" />
  }
];

export default customerRoutes;
